import React from "react";
import ConfirmationModal from "app/components/common/ConfirmationModal";

const DisconnectCalendarModal = ({
  show,
  onHide,
  onConfirm,
  email,
  isDisconnecting = false,
}) => {
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      title="Disconnect Account?"
      confirmLabel="Disconnect"
      confirmVariant="danger"
      isLoading={isDisconnecting}
      staticWhileLoading
      className="disclaimer-how-it-works-modal-wrapper"
    >
      <div className="my-3">
        <p className="mb-2">
          Disconnecting will stop syncing jobs to your calendar
          and disable automated emails for{" "}
          <strong className="text-primary">{email}</strong>.
        </p>
      </div>
    </ConfirmationModal>
  );
};

export default DisconnectCalendarModal;
